import React from 'react';

interface EmergencyHelpButtonProps {
  onClick: () => void;
  isVisible: boolean;
  className?: string;
}

/**
 * EmergencyHelpButton - Always visible help button
 * Part of MVP-UX-001: Emma Continuity System
 */
export function EmergencyHelpButton({ onClick, isVisible, className = '' }: EmergencyHelpButtonProps) {
  if (!isVisible) return null;

  return (
    <button
      onClick={onClick}
      className={`
        relative inline-flex items-center justify-center
        w-10 h-10 
         
        text-white 
        rounded-full 
        shadow-lg hover:shadow-xl
        transition-all duration-200
        focus:ring-2 focus:ring-offset-2
        group
        ${className}
      `}
      title="Get Emma Help"
      aria-label="Get immediate help from Emma"
    >
      {/* Help Icon */}
      <svg 
        className="w-5 h-5" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
        />
      </svg>

      {/* Pulse animation for urgency */}
      <div className="absolute -top-1 -right-1 w-3 h-3">
        <div className="animate-ping absolute inline-flex h-full w-full rounded-full style={{ backgroundColor: 'rgba(220, 38, 38, 0.6)'}} opacity-75"></div>
        <div className="relative inline-flex rounded-full h-3 w-3 style={{ backgroundColor: '#DC2626'}}" ></div>
      </div>

      {/* Tooltip */}
      <div className="
        absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2
        px-3 py-1 text-xs font-medium text-white bg-gray-900 rounded-lg
        opacity-0 group-hover:opacity-100
        transition-opacity duration-200
        whitespace-nowrap
        pointer-events-none
      ">
        Get Emma Help
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-px">
          <div className="w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
        </div>
      </div>
    </button>
  );
}